<template>
    <div>
        <NavBar shared="true" noleft="true" />
        <main>
            <div class="no_data_container">
                <span>Sorry!</span>
                But there is no data in this project:(
            </div>
        </main>
    </div>
</template>

<script>
import NavBar       from "../NavBar";

export default {
    name: "ProjectsList",
    components:{
        NavBar
    },
    created() {
        this.$vuetify.theme.dark = true;
    }
};
</script>
